import { render, staticRenderFns } from "./document-icon.vue?vue&type=template&id=abe8ca54"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abe8ca54')) {
      api.createRecord('abe8ca54', component.options)
    } else {
      api.reload('abe8ca54', component.options)
    }
    module.hot.accept("./document-icon.vue?vue&type=template&id=abe8ca54", function () {
      api.rerender('abe8ca54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/document-icon.vue"
export default component.exports